import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "z-40" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, " プッシュ通知管理", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, " ユーザ管理", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, " ユーザ変更申請", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", null, " テンプレート管理", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Slide = _resolveComponent("Slide");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Slide, { closeOnNavigation: true }, {
            default: _withCtx(() => [
                ($data.isSysAdmin)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/release-status",
                        id: "release-manage"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_2
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                    to: "/user",
                    id: "user-manage"
                }, {
                    default: _withCtx(() => [
                        _hoisted_3
                    ]),
                    _: 1
                }),
                _createVNode(_component_router_link, {
                    to: "/update-request",
                    id: "request-manage"
                }, {
                    default: _withCtx(() => [
                        _hoisted_4
                    ]),
                    _: 1
                }),
                ($data.isSysAdmin)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "/template",
                        id: "template-manage"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_5
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
